<template>
  <van-popup v-model="popShow" :close-on-click-overlay="false" position="bottom">
    <div ref="popupRef" class="verify_popup">
      <img :class="$store.state.isMirroring && 'mirror'" class="close" src="@/assets/close.png" @click="closePopup" />
      <div class="title">{{ showResetPassword ? $t('redesign.resetPwd') : $t('redesign.retrievePwd') }}</div>
      <div class="account">{{ email }}</div>
      <div v-show="!showResetPassword" class="input_item">
        <CommonInput
          v-model="smsCode"
          type="tel"
          inputmode="numeric"
          :placeholder="$t('common.emailCode')"
          theme="white"
          :max-length="VALID_CODE_LENGTH"
          auto-focus
        >
          <div class="send_span" :class="msgValidating && 'disabled'" @touchend.stop.prevent="sendEmailCode">
            {{ !msgValidating ? (firstSendMsg ? $t('common.send') : $t('common.resend')) : count + 's' }}
          </div>
        </CommonInput>
      </div>
      <div v-show="showResetPassword" class="input_area">
        <!-- 输入密码 -->
        <CommonInput
          v-model="password"
          theme="white"
          :type="showPassword ? 'text' : 'password'"
          :placeholder="$t('redesign.newPwdPlaceholder')"
          show-clear
          auto-focus
          :on-focus="focusPasswordInput"
          :on-blur="inputBlur"
        >
          <img
            v-show="!showPassword"
            class="password_status_icon"
            src="@/assets/password_hidden.png"
            @touchend.stop.prevent="showPassword = !showPassword"
          />
          <img
            v-show="showPassword"
            class="password_status_icon"
            src="@/assets/password_visible.png"
            @touchend.stop.prevent="showPassword = !showPassword"
          />
        </CommonInput>
        <div v-show="passwordWarning" class="country_toast">
          <img class="note_icon" src="@/assets/note_icon.png" alt="" />
          {{ $t('loginAndRegister.pwdNote') }}
        </div>
        <!-- 再次输入 -->
        <CommonInput
          class="pwd_input"
          v-model="confirmPassword"
          theme="white"
          :type="showSecondPassword ? 'text' : 'password'"
          :placeholder="$t('redesign.reenterNewPwdPlaceholder')"
          show-clear
          :on-focus="focusPasswordInput"
        >
          <img
            v-show="!showSecondPassword"
            class="password_status_icon"
            src="@/assets/password_hidden.png"
            @touchend.stop.prevent="showSecondPassword = !showSecondPassword"
          />
          <img
            v-show="showSecondPassword"
            class="password_status_icon"
            src="@/assets/password_visible.png"
            @touchend.stop.prevent="showSecondPassword = !showSecondPassword"
          />
        </CommonInput>
        <div v-show="confirmPassword" class="country_toast">
          <img class="note_icon" src="@/assets/note_icon.png" alt="" />
          {{ $t('loginAndRegister.reenterPwdNote') }}
        </div>
      </div>
      <CommonBtn
        class="next_btn"
        :text="showResetPassword ? $t('common.done') : $t('common.next')"
        :disabled="showResetPassword ? !canNext : !smsCode"
        :on-click="showResetPassword ? revisePassword : checkEmailCode"
      />
    </div>
  </van-popup>
</template>

<script>
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn.vue'
import { Toast } from 'vant'
import md5 from 'js-md5'
import throttle from 'lodash/throttle'
import { isInWebView } from '@/utils'
import { VALID_CODE_LENGTH } from '@/utils/constants'

export default {
  name: 'LoginVerifyPopup',
  components: {
    CommonInput,
    CommonBtn
  },
  props: {
    value: { type: Boolean, required: true },
    phone: { type: String, required: true }
  },
  data() {
    return {
      VALID_CODE_LENGTH,
      popShow: false,
      email: '',
      smsCode: '',
      msgValidating: false,
      count: 59,
      firstSendMsg: true,
      showResetPassword: false,
      canNext: false,
      password: '',
      confirmPassword: '',
      showPassword: false,
      showSecondPassword: false,
      passwordWarning: false,
      passwordError: false,
      interval: undefined
    }
  },
  watch: {
    async value(val) {
      this.popShow = val
      if (val) {
        if (!this.email) {
          await this.getEmailWithPhone()
        }
        this.sendEmailCode()
        if (isInWebView()) {
          document.addEventListener('touchstart', this.checkInputFocus)
          this.checkInputFocus()
        }
      } else {
        if (isInWebView()) {
          document.removeEventListener('touchstart', this.checkInputFocus)
        }
      }
    },
    popShow(val) {
      this.$emit('input', val)
    },
    password() {
      this.change()
    },
    confirmPassword() {
      this.change()
    },
    smsCode(val) {
      if (val.length === this.VALID_CODE_LENGTH) {
        this.checkEmailCode()
      }
    }
  },
  methods: {
    checkInputFocus() {
      setTimeout(() => {
        if (document.activeElement.tagName === 'INPUT') {
          this.$refs.popupRef.style.paddingBottom = '35vh'
        } else {
          this.$refs.popupRef.style.paddingBottom = '0.24rem'
        }
      }, 200)
    },
    async getEmailWithPhone() {
      await this.$http
        .post(window.serverPath + '/api/auth/getEmailWithPhone?phone=' + this.phone)
        .then((res) => {
          if (res.data.code === '200') {
            this.email = res.data.message
          } else if (res.data.code === '400') {
            Toast(this.$t('loginAndRegister.noLinkedEmailToast'))
            this.$emit('input', false)
          } else if (res.data.code === '60007') {
            Toast(this.$t('loginAndRegister.unregisteredToast'))
            this.$emit('input', false)
          } else {
            Toast(res.data.message)
            this.$emit('input', false)
          }
        })
        .catch((err) => {
          console.log('异常', err)
        })
    },
    sendEmailCode() {
      if (this.msgValidating) {
        return
      }
      const $this = this
      const url = window.serverPath + '/api/auth/getForgotEmailCode/RESET_LOGIN_PASSWORD?phone=' + this.phone
      this.$http
        .get(url)
        .then((res) => {
          if (res.data.code === '200') {
            $this.msgValidating = true
            $this.firstSendMsg = false
            $this.interval = window.setInterval(() => {
              $this.count -= 1
              if ($this.count <= 0) {
                clearInterval($this.interval)
                $this.msgValidating = false
                $this.count = 59
              }
            }, 1000)
          } else if (res.data.code === '60001') {
            Toast(this.$t('loginAndRegister.userExistToast'))
            $this.msgValidating = false
            $this.count = 59
          } else {
            Toast({
              message: res.data.message
            })
            $this.msgValidating = false
            $this.count = 59
          }
        })
        .catch(() => {
          console.log('异常')
          $this.msgValidating = false
          $this.count = 59
        })
    },
    checkEmailCode: throttle(
      function () {
        if (!this.smsCode) {
          Toast(this.$t('basicLevel.verificationCodeEmpty'))
          return
        }
        const params = { type: 'EMAIL' }
        params.phone = this.phone
        params.validCode = this.smsCode
        this.$http
          .post(window.serverPath + '/api/auth/checkCodeStatus/RESET_LOGIN_PASSWORD', params)
          .then((res) => {
            if (res.data.code === '200' && res.data.data) {
              this.showResetPassword = true
            } else {
              Toast({
                message: this.$t('accountSecurity.wrongCodeToast')
              })
            }
          })
          .catch(() => {
            console.log('异常')
          })
      },
      5000,
      { trailing: false }
    ),
    focusPasswordInput() {
      this.passwordError = false
    },
    inputBlur() {
      this.passwordError = !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/.test(this.password)
      if (this.passwordError) {
        this.passwordWarning = true
      } else {
        this.passwordWarning = false
      }
    },
    change() {
      if (this.password && this.confirmPassword) {
        this.canNext = true
      } else {
        this.canNext = false
      }
    },
    revisePassword() {
      const $this = this
      const phone = this.phone
      this.passwordError = !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/.test(this.password)
      if (this.passwordError) {
        Toast({
          message: this.$t('loginAndRegister.pwdFormatToast')
        })
      } else {
        if (this.password === this.confirmPassword && !this.passwordError) {
          const params = {}
          params.password = md5(this.password)
          params.msgCode = this.smsCode
          params.phone = phone
          this.$http
            .post(window.serverPath + '/api/auth/resetPasswordFormEmail', params)
            .then((res) => {
              if (res.data.code === '200') {
                Toast.success({
                  message: this.$t('loginAndRegister.resetSuccessToast'),
                  onClose: function () {
                    $this.closePopup()
                  }
                })
              } else {
                Toast({
                  message: res.data.message
                })
              }
            })
            .catch(() => {
              console.log('异常')
            })
        } else {
          Toast({
            message: this.$t('loginAndRegister.pwdNotMatchToast')
          })
        }
      }
    },
    // 关闭并清空状态
    closePopup() {
      this.popShow = false
      this.smsCode = ''
      this.password = ''
      this.confirmPassword = ''
      this.showPassword = false
      this.showSecondPassword = false
      this.canNext = false
      this.passwordError = false
      this.passwordWarning = false
      this.showResetPassword = false
      clearInterval(this.interval)
      this.interval = undefined
      this.msgValidating = false
      this.count = 59
      this.firstSendMsg = true
    }
  }
}
</script>

<style scoped>
.verify_popup {
  padding: 0.24rem;
  background: #fff;
  border-radius: 0.16rem 0.16rem 0 0;
  position: relative;
}

.close {
  position: absolute;
  top: 0.24rem;
  right: 0.24rem;
  width: 0.24rem;
  height: 0.24rem;
}

.close.mirror {
  left: 0.24rem;
  right: auto;
}

.title {
  display: flex;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
  margin-bottom: 0.04rem;
  max-width: calc(100% - 0.4rem);
}

.account {
  display: flex;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  margin-bottom: 0.2rem;
  direction: ltr;
}

.send_span {
  color: #3fbb70;
  font-size: 0.14rem;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  white-space: nowrap;
}

.send_span.disabled {
  color: #828282;
}

.next_btn {
  margin: 0.48rem auto 0.12rem;
  font-size: 0.16rem !important;
}

.country_toast {
  width: 100%;
  display: flex;
  font-size: 0.12rem;
  font-weight: 400;
  color: #ff840b;
  margin: 0.06rem 0 0.12rem;
  align-items: center;
}

.note_icon {
  width: 0.12rem;
  height: 0.12rem;
  margin-inline-end: 0.02rem;
}

.password_status_icon {
  margin-inline-start: 0.2rem;
  width: 0.2rem;
  height: 0.2rem;
}

.pwd_input {
  margin-top: 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/ForgetPasswordPopup.vue